export const MERCURY_FORM_TEXTS = {
  LOADING: 'Loading...',
  GENERIC_ERROR: 'Something went wrong while loading the form. Please try again in a few minutes.',
  NO_FORM_FOUND: 'No valid form configuration found for this offering.',
  NAVIGATION_ERROR: 'Form is not available. Please try again later.',
  ERROR: 'Error',
  FORM_LOAD_ERROR_TITLE: 'Failed to load form',
  FORM_LOAD_ERROR: 'We could not load this form. Please refresh the page or try again in a few minutes.',
  FORM_CONFIG_ERROR: 'Failed to fetch form configuration',
  FORM_NOT_FOUND_TITLE: 'No form found',
  FORM_NOT_FOUND: 'This form is no longer available. Please return to My Offerings and try another request.',
  POPUP_BLOCKED: 'Failed to load form',
  FULFILLMENT_TITLE: 'Fulfill your request for ',
  FORM_INVALID_FIELD: 'Invalid or missing fields',
  FORM_MISSING_FIELDS: 'Please fill out the missing fields:\n',
  FORM_SUBMIT_SUCCESS: '\nCheck your email for further details',
  FORM_SUBMIT_FAILED: 'Form submission was rejected. Please review the highlighted fields and try again.',
  FORM_SUBMIT_FAILED_LATER: 'We could not submit your request right now. Please try again in a few minutes.',
  PANORAMA_BACK_BUTTON: 'Go back to panorama.roche.com',
  SUBMISSION_ERROR: 'Submission Error',
  FORM_SUBMIT_REJECTED_TITLE: "We couldn't submit your request",
  // Follows the backend's own rejection reason (TicketResponseMessage).
  FORM_SUBMIT_REJECTED_HINT: 'Please try again later. If the issue persists, contact support.',
  // Timeout-specific copy — surfaced when the R2F backend does not respond
  // within MERCURY_REQUEST_TIMEOUT_MS. Tell the user the submit may still be
  // processing so they don't blindly retry and create duplicate requests.
  FORM_SUBMIT_TIMEOUT_TITLE: 'The server did not respond',
  FORM_SUBMIT_TIMEOUT_MESSAGE:
    'Your request may still be processing. Please check My Offerings before submitting again to avoid a duplicate.',
  FORM_LOAD_TIMEOUT_MESSAGE:
    'The server did not respond in time. Please refresh the page or try again in a few minutes.',
  // Backend returned a structured Mulesoft error `{statusCode, statusMessage,
  // statusDetails, correlationId}`. Surface the correlationId so the user
  // can quote it to support — Mulesoft ops can grep logs directly for it.
  FORM_LOAD_BACKEND_ERROR:
    'We could not load this form right now. Please try again in a few minutes.',
  FORM_SUBMIT_BACKEND_ERROR:
    'We could not submit your request right now. Please try again in a few minutes.',
  BACKEND_ERROR_REFERENCE_PREFIX: 'If the problem persists, share this reference with support: ',
};

